import {Plugin} from 'prosemirror-state';

/**
 * A Plugin which intercepts the paste event for text.
 * Detects Yuja video links and converts them to embedded videos.
 */
export const pasteYujaEmbedPlugin = new Plugin({
  props: {
    handlePaste(view, event) {
      let text = event.clipboardData?.getData('text/plain') || '';

      if (!isYujaLink(text)) {
        return false;
      }

      const {schema, tr} = view.state;

      const params = parseYujaParams(text);
      if (!params.videoId) {
        return false;
      }

      const embedNode = schema.nodes.yuja_embed.create({
        videoId: params.videoId,
        nodeId: params.nodeId,
        accountId: params.accountId,
      });

      // Replace the selection with the embedded video
      tr.replaceSelectionWith(embedNode);
      view.dispatch(tr);

      return true; // Prevent default pasting behavior
    },
  },
});

/**
 * Checks if the provided string is a valid Yuja video link
 */
function isYujaLink(str: string): boolean {
  try {
    const url = new URL(str);

    // Check for Yuja domain patterns (adjust as needed for your Yuja instance)
    if (!url.hostname.includes('yuja.com')) {
      return false;
    }

    // Check if it's a video link
    if (url.pathname.includes('/V/Video')) {
      // Must have a video ID parameter
      return url.searchParams.has('v');
    }

    return false;
  } catch (e) {
    return false;
  }
}

/**
 * Parse Yuja URL parameters
 */
function parseYujaParams(text: string) {
  try {
    const url = new URL(text);

    return {
      videoId: url.searchParams.get('v'),
      nodeId: url.searchParams.get('node'),
      accountId: url.searchParams.get('a'),
    };
  } catch (e) {
    return {
      videoId: null,
      nodeId: null,
      accountId: null,
    };
  }
}
